<template>
  <div v-if="delay" dir="rtl">
    <PopupComponent :showClose="false" v-if="showPopup" @close="closePopup" variant="top-center" containerClass="mw928">
      <div class="d-flex flex-row">
        <ImgImage :img="$responsive(data.body.pictures)" />
        <div class="d-flex flex-column">
          <div class="d-flex flex-row">
            <div class="f26-l30-m df30-l30-b flex-fill dpadding-top-50" v-html="data.header.text_html"></div>
            <div class="f26-l30-m df30-l30-b bold pointer" @click="closePopup">X</div>
          </div>
          <HorizontalSplitter class="margin-top-20 mobile-only" />
          <div class="f16-l19 df16-l20 c58 margin-top-20" v-html="data.body.text_html"></div>
          <div :class="buttonsContainerClass">
            <div class="flex-grow-1 desktop-only"></div>
            <ButtonComponent class="margin-top-20" :caption="data.submit.label" @click="closePopup" @keyup.enter="closePopup"></ButtonComponent>
            <div class="flex-grow-1 desktop-only"></div>
            <ButtonComponent class="margin-top-20" v-for="(btn,idx) in data.buttons" :key="idx" :caption="btn.label" :link="btn.url" :variant="btn.variant"></ButtonComponent>
            <div class="flex-grow-1 desktop-only"></div>
          </div>
        </div>
      </div>
    </PopupComponent>
  </div>
</template>
<script>
/* global $ */
import {fetch3} from '@/modules/configuration.js'
import PopupComponent from '@/components/PopupComponent.vue';
import ImgImage from "@/components/generic/ImgImage.vue";
import ButtonComponent from "@/components/form/ButtonComponent";
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue";
export default {
  components: {
    PopupComponent,
    ImgImage,
    ButtonComponent,
    HorizontalSplitter
  },
  props: {
    delay: Number
  },
  data() {
    return {
      timeoutHandler: null,
      showPopup: false,
      data: {}
    }
  },
  computed: {
    buttonsContainerClass() {
      return this.$isDesktop() ? "d-flex flex-row " : "d-flex flex-column "
    }
  },
  mounted() {
    if (this.delay) {
      const $this = this;
      this.timeoutHandler = setTimeout(() => {
        if ($("body").hasClass("popupisopen")) {
          return;
        }
        $this.getData();
      }, this.delay || 8000);
    }
  },
  unmounted() {
    if (this.timeoutHandler)
      clearTimeout(this.timeoutHandler);
  },
  methods: {
    closePopup() {
      this.showPopup = false;
    },
    async getData() {
      const data = await fetch3(this, {
        url: "/popup"
      });
      this.data = data;
      this.showPopup = true;
    }
  }
}
</script>